function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Artboard",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "v_flip/24"
}, React.createElement("path", {
  d: "M10.4959832,4.13296905 C10.8076458,4.31098782 11,4.6423802 11,5.00130116 L11,18 C11,19.1045695 10.1045695,20 9,20 L2.00407377,20 C1.45178902,20 1.00407377,19.5522847 1.00407377,19 C1.00407377,18.8260339 1.04945737,18.6550772 1.13574166,18.5040168 L9.13166789,4.50531796 C9.40559185,4.02575137 10.0164166,3.85904509 10.4959832,4.13296905 Z M13.5080906,4.13296905 C13.9876571,3.85904509 14.5984819,4.02575137 14.8724059,4.50531796 L14.8724059,4.50531796 L22.8683321,18.5040168 C22.9546164,18.6550772 23,18.8260339 23,19 C23,19.5522847 22.5522847,20 22,20 L22,20 L15.0040738,20 C13.8995043,20 13.0040738,19.1045695 13.0040738,18 L13.0040738,18 L13.0040738,5.00130116 C13.0040738,4.6423802 13.196428,4.31098782 13.5080906,4.13296905 Z M8.999,8.769 L3.726,18 L9,18 L8.999,8.769 Z M15.0050738,8.769 L15.0040738,18 L20.2780738,18 L15.0050738,8.769 Z",
  id: "v_flip"
})));

var SvgIHorizontalFlip = function SvgIHorizontalFlip(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIHorizontalFlip, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/i-horizontal-flip.ef458a29.svg";
export { ForwardRef as ReactComponent };